import trim from "lodash/trim";
import truncate from "lodash/truncate";

export const TITLE_MAX_LENGTH = 250;
export const truncateTitle = (title?: string) => truncate(trim(title), { length: TITLE_MAX_LENGTH });
